import { Pipe, PipeTransform } from '@angular/core';
import { Date } from '../../shared';
/*
 * Usage:
 *   obj: Date | dateIso
*/
@Pipe({name: 'dateIso'})
export class DateIsoPipe implements PipeTransform {
  transform(date: Date): string {
    return `${date.year}-${date.month}-${date.day}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/pipes/date-iso.pipe.ts